import { ThemeUICSSObject } from "theme-ui";

export const navigationMenuPadding = 12;

export const menuBarStyles: ThemeUICSSObject = {
  height: "72px",
  zIndex: 2,
  width: "100%",
  bg: "n0",
  position: "static",

  borderBottom: ["1px solid", null, "none"],
  borderColor: ["n100", null, "unset"],
};

export const menuStyles: ThemeUICSSObject = {
  display: "flex",
  flexDirection: "column",
  minWidth: "258px",
  borderRadius: "8px",
  alignItem: "flex-start",
  bg: "n0",
  outline: "none",
  padding: `${navigationMenuPadding}px`,
};

export const menuSeparatorStyles: ThemeUICSSObject = {
  display: "block",
  height: 0,
  width: `calc(100% + ${navigationMenuPadding * 2}px)`,
  border: 0,
  borderTop: "1px solid",
  borderColor: "n100",
  m: "8px 0",
  p: 0,
  boxSizing: "border-box",
  marginLeft: `${-navigationMenuPadding}px`,
};

export const navItemsStyles: ThemeUICSSObject = {
  border: "none",

  '&[data-component="menu-item"]': {
    margin: ["4px 0", "0 8px", "0 8px"],
  },

  '& > [data-content-wrapper="true"]': {
    justifyContent: "flex-start",
  },

  '&[aria-expanded="true"] [data-right-icon-wrapper]': {
    transform: "rotate(180deg)",
  },

  '& [data-right-icon-wrapper="true"], & [data-left-icon-wrapper="true"]': {
    color: "n500",
  },
  color: ["n1000", null, null],
  width: ["100%", "100%", "unset"],
  '&:not([aria-disabled="true"])': {
    "&:hover": {
      color: ["n1000", null, null],
    },
    '&:active, &[data-active="true"]': {
      color: ["n1000", null, null],
    },
  },
};

export const navItemsButtonStyles: ThemeUICSSObject = {
  '&[aria-expanded="true"], &[aria-selected="true"]': {
    backgroundColor: "n50",
  },
};

export const navItemsLinkStyles: ThemeUICSSObject = {
  backgroundColor: "transparent",

  '&:not([disabled]), &:not([aria-disabled="true"])': {
    "&:hover": {
      backgroundColor: "n50",
    },

    '&:active, &[data-active="true"]': {
      "&:not(:hover)": {
        backgroundColor: "transparent",
      },
      border: "none",
      color: "n1000",
      "&:after": {
        backgroundColor: "vo500",
        transform: "scaleX(1)",
      },
    },
  },

  "&:after": {
    content: "''",
    display: "block",
    height: "4px",
    width: "100%",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    transform: "scaleX(0)",
    transition: "200ms transform",
  },
};

export const nestedMenuAnimationStyles: ThemeUICSSObject = {
  transition: "opacity 250ms ease-in-out, transform 250ms ease-in-out",
  opacity: 0,
  transformOrigin: "top center",
  transform: "scaleY(0)",
  "&[data-enter]": {
    opacity: 1,
    transform: "scaleY(1)",
  },
};

export const nestedMenuStyles: ThemeUICSSObject = {
  '& [data-content-wrapper="true"] [data-right-icon-wrapper="true"]': {
    marginLeft: "auto !important",
  },
  '& [data-component="menu-item"]': {
    padding: "8px 12px",
    margin: 0,
  },
  '& [data-children="true"]': {
    color: "n1000",
  },
};

export const nestedMenuRevealAnimationStyles: ThemeUICSSObject = {
  width: "100%",
};

export const fullScreenDropdownDialogStyles: ThemeUICSSObject = {
  position: "fixed",
  top: 72,
  right: 0,
  left: 0,
  width: ["100%", "100%", "100%"],
};

export const fullScreenDropdownContainerStyles: ThemeUICSSObject = {
  width: "100%",
  height: "calc(100vh - 72px)",
  overflow: "auto",

  "[data-component='dialog-header']": {
    borderBottom: "1px solid",
    borderColor: "n100",
  },
  "[data-component='dialog-footer']": {
    borderTop: "1px solid",
    borderColor: "n100",
  },
};

export const fullScreenDropdownAnimationStyles: ThemeUICSSObject = {
  width: "100%",
};
